import React from 'react';

interface CollapseChevronProps {
  expanded: boolean;
  onToggle: () => void;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * CollapseChevron
 * 
 * A subtle expand/collapse indicator.
 * - ▼ when expanded
 * - ▶ when collapsed
 * - Smooth rotation animation
 */
const CollapseChevron: React.FC<CollapseChevronProps> = ({
  expanded,
  onToggle,
  size = 'md',
  className = '',
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
  };

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      className={`
        ${sizeClasses[size]}
        flex items-center justify-center
        text-gray-400 hover:text-gray-600
        transition-all duration-200
        rounded hover:bg-gray-100
        ${className}
      `.trim()}
      aria-label={expanded ? 'Inklappen' : 'Uitklappen'}
      aria-expanded={expanded}
    >
      <svg
        className={`
          w-3 h-3
          transition-transform duration-200 ease-out
          ${expanded ? 'rotate-90' : 'rotate-0'}
        `.trim()}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  );
};

export default CollapseChevron;
